module.exports = __webpack_public_path__ + "img/login_bgd.d4aa399a.png";